import type { SchemaNames } from "instantdb/types";
import { db } from "@/lib/dexie/dexieDB";
import { tryCatch } from "@/lib/try-catch";

// Original sidebar functions
export async function getResourceOrder(
  slug: SchemaNames,
): Promise<Map<string, number> | undefined> {
  const { data: entry, error } = await tryCatch(db.resourceOrdering.get(slug));

  if (error) {
    console.error("Error reading from IndexedDB:", error);
    return undefined;
  }

  return entry ? new Map(JSON.parse(entry.value)) : undefined;
}

export async function setResourceOrder(
  slug: SchemaNames,
  value: Map<string, number>,
): Promise<boolean> {
  const { error } = await tryCatch(
    db.resourceOrdering.put({
      key: slug,
      value: JSON.stringify(Array.from(value.entries())),
    }),
  );

  if (error) {
    console.error("Error writing to IndexedDB:", error);
    return false;
  }

  return true;
}
